import React, { useState } from 'react'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'
import { Modal, Button, TextArea } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import useApi from 'hooks/useApi'

export default NiceModal.create(({ task, order }) => {
  const [loading, setLoading] = useState(false)
  const [note, setNote] = useState('')
  const { formatMessage } = useIntl()
  const modal = useModal()

  const [settings,,, reload] = useApi(`/notification/getNotificationSettingsForTaskId?taskId=${task.uid}`)

  const onReject = (event) => onSubmit(event, false)
  const onApprove = (event) => onSubmit(event, true)

  const onSubmit = (event, approved) => {
    event.preventDefault()

    setLoading(true)

    const body = new FormData()
    body.append('taskId', task.uid)
    body.append('comment', note)
    body.append('approved', approved)

    fetch(`/ordertask/qualityCheck.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then((response) => {
        setLoading(false)

        if (!response.success) {
          toastr.error(response.errors.join(', '))
        } else {
          modal.resolve()
          modal.remove()
        }
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => loading ? undefined : onApprove()}
      title={formatMessage(messages.title)}
    >
      <form className="space-y-8" onSubmit={onApprove} disabled={loading}>
        <TextArea
          label={formatMessage(messages.commentLabel)}
          placeholder={formatMessage(messages.commentPlaceholder)}
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />

        <ol className="list-decimal list-inside text-sm">
          <FormattedMessage
            {...messages.sideEffects}
            values={{
              li: (chunks) => <li className="">{chunks}</li>,
            }}
          />
        </ol>

        <div className="flex justify-end items-center space-x-2">
          <Button type="submit" size="sm" disabled={loading} state="positive">
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.submit} />
            ) }
          </Button>

          <Button type="button" size="sm" disabled={loading} onClick={onReject} state="negative">
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.reject} />
            ) }
          </Button>

          <Button type="button" size="sm" onClick={() => modal.remove()} variant="outline">
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </form>
    </Modal>
  )
})
